"use strict";

module.exports = require("./ScreenCapture.js");